export default {
  getCalendarOptions: (state) => {
    return state.calendarOptions
  },
  getSelectedCalendars: (state) => {
    return state.selectedCalendars
  },
}